
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Experience the thrill of water sports in Goa. From exciting jet skiing to relaxing scuba diving, enjoy a fun-filled day on the water with friends and family.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Dive into adventure with the best water sports package in Goa. Enjoy jet skiing, parasailing, and more at beautiful beaches.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Get ready for adventure with the Goa Water Sports Package. Enjoy thrilling activities like jet skiing and scuba diving at stunning beaches.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'water sports in north goa, best water sports in north goa, best beach for water sports in north goa, water sports in north goa beaches, which beach is best for water sports in north goa, water sports in north goa prices, water sports in baga beach, water sports in baga beach timings',
        },
      
      ],
    };
  },


  components: {},
  data() {
    return {

      reasons: [
  {
    title: "Thrilling Activities",
    text: "Experience heart-pounding adventures with exciting water sports like jet skiing, parasailing, and scuba diving!",
  },
  {
    title: "Fun for All Ages",
    text: "Whether you're a seasoned adventurer or a first-timer, there's a water sport for everyone to enjoy!",
  },
  {
    title: "Safety First",
    text: "All activities are conducted with safety in mind, with trained instructors ensuring a secure experience.",
  },
  {
    title: "Convenient Booking",
    text: "Easily book your water sports package through the Goa App for hassle-free planning and great deals!",
  },
],

      title: 'Water Sports in North Goa - Best Beach for Water Sports in North Goa',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/watersports/water-sports-in-north-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/watersports/water-sports-in-north-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/watersports/water-sports-in-north-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Water Sports in North Goa",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Water Sports in North Goa - Book @ ₹1499 Flat 40% Off",
  "description": "Enjoy the ultimate Water Sports in North Goa with jet skiing, parasailing, banana boat, bumper, and speed boat rides for an action-packed experience!",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1499",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/watersports/water-sports-in-north-goa",
        "url": "https://www.goa.app/watersports/water-sports-in-north-goa",
        "name": "Water Sports in North Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A12%3A45.706Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Fz06SDh5Jpn3lM19ur6OEuJ6o5BjfswZJo3p%2FUObpTs8onAzGRTvyn5mrSw39htXZB6zpjRrOL%2BD9vhBjqzDY7aK%2BMSqmE5ROUCDm81w59Pnvz%2Fot5cKEasuFulZTax3iXLIP7IpuOdv3wjsnkUN7SBQnq3ZQhX3PPdYOoN6r4qedwDfkaIGfKHCzJa%2F275L3MqUAkmd8AOxTuRa8L%2BGVURsbZwPr2HyUoMZnRQWJAN%2F%2FH5y5pH6aEREpzGblqjRDu9VPQwPzIubBN86mT8YgWANS3x9QnQYRNfIUr2CgTy92DmSOjVsjSQeONQWRwYHLJUaX9I1FkzrRLjMKTcShQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "The Water Sports in North Goa offers an exciting mix of jet skiing, parasailing, banana boat rides, bumper rides, and speed boat experiences. Perfect for adventure lovers, this package promises thrills and unforgettable memories on Goa’s beautiful waters.",
        "breadcrumb": {
            "@id": "https://www.goa.app/watersports/water-sports-in-north-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/watersports/water-sports-in-north-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What water sports are available in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In North Goa, you can enjoy a variety of water sports including jet skiing, parasailing, banana boat rides, scuba diving, and windsurfing."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of water sports in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prices for water sports in North Goa typically start from ₹800 for basic activities and can go up to ₹3,000 for premium packages that include scuba diving."
      }
    },
    {
      "@type": "Question",
      "name": "Is scuba diving available in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many water sports operators in North Goa offer scuba diving experiences suitable for both beginners and experienced divers."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need prior experience for water sports in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most water sports in North Goa are beginner-friendly, and trained instructors are available to guide you, especially for activities like jet skiing and scuba diving."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for water sports in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for water sports in North Goa is from November to April when the weather is pleasant and ideal for beach activities."
      }
    },
    {
      "@type": "Question",
      "name": "Are safety measures provided during water sports?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all water sports operators in North Goa prioritize safety and provide essential gear, including life jackets and helmets, for all participants."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book water sports activities online in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes! You can easily book water sports activities online through various platforms, including the Goa App, which often features special deals."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for water sports in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's best to wear a swimsuit, comfortable clothing, and flip-flops for water sports in North Goa. Applying sunscreen is also recommended to protect your skin from the sun."
      }
    },
    {
      "@type": "Question",
      "name": "Are meals included in water sports packages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some water sports packages in North Goa may include meals, while others might only offer refreshments. Check package details before booking."
      }
    },
    {
      "@type": "Question",
      "name": "How do I find the best water sports package in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To find the best water sports package in North Goa, compare options online, read reviews, and look for discounts on platforms like the Goa App."
      }
    }
        ]
      }
    ]
  };
},


};



  